import {BookId} from "./BookId";

export const CHOOSE_STORY_NAME = "ChooseStory";

export interface IChooseStoryData {
    openBookId?: BookId;
    storyFinished?: boolean;
    sceneRender?: PIXI.RenderTexture;
}
